export function Hero() {
    return (
        <section className="hero">
            <div className="hero-text">
                <p className="hero-eyebrow">Hausarztpraxis · Rüsselsheim am Main</p>
                <h1 className="hero-title">Ihre Gesundheit in guten Händen</h1>
                <p className="hero-sub">
                    Wir begleiten Sie und Ihre Familie mit persönlicher und medizinischer
                    Versorgung bis zur Behandlung.
                </p>
                <p className="hero-sub2">Innerhalb der Sprechstunden sind wir für Sie jederzeit telefonisch erreichbar</p>
                <p className="hero-fett">06142 – 17 15 44</p>
                <div className="hero-btns">
                    <a href="#kontakt">
                        <button className="btn-primary">Termin vereinbaren</button>
                    </a>
                    <a href="#leistungen">
                        <button className="btn-secondary">Leistungen ansehen</button>
                    </a>
                </div>
            </div>
            <div className="hero-visual">
                {[
                    {label: "Sprechstunde heute", val: "08:00 – 12:00 Uhr", sub: "Nachmittags: 15:00 – 18:00 Uhr"},
                    {label: "Termin", val: "06142 – 17 15 44", sub: ""},
                    {label: "Notfall", val: "116 117", sub: "Ärztlicher Bereitschaftsdienst"},
                ].map(({label, val, sub}) => (
                    <div className="hero-card" key={label}>
                        <div className="hero-card__label">{label}</div>
                        <div className="hero-card__val">{val}</div>
                        {sub && <div className="hero-card__sub">{sub}</div>}
                    </div>
                ))}
            </div>
        </section>
    );
}